var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.coLoader
    ? _c(
        "div",
        [
          _vm.receptions
            ? _c("sub-navigation-title", {
                attrs: {
                  title: _vm.receptionName,
                  source: _vm.receptions,
                  "text-field": "name",
                  "load-more-visible": true
                },
                on: {
                  loadMore: _vm.handleGoBack,
                  click: _vm.handleOnClickReception
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(data) {
                      return data.item
                        ? [
                            _c("v-list-tile-title", {
                              staticStyle: { display: "inline-block" },
                              domProps: { textContent: _vm._s(data.item.text) }
                            })
                          ]
                        : undefined
                    }
                  }
                ]),
                model: {
                  value: _vm.dtMenu,
                  callback: function($$v) {
                    _vm.dtMenu = $$v
                  },
                  expression: "dtMenu"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list",
            { staticClass: "sidebar-apartment  mx-3" },
            [
              _vm._l(_vm.coReceptionSections, function(type, index) {
                return _c(
                  "v-list-tile-content",
                  { key: type.id, staticClass: "pa-1" },
                  [
                    _c("div", { staticStyle: { display: "inline-block" } }, [
                      _c("div", {
                        staticStyle: {
                          "margin-top": "7px",
                          "margin-right": "7px",
                          float: "left",
                          "background-color": "white",
                          width: "7px",
                          height: "7px",
                          "border-radius": "1.5px"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "min-width": "20px",
                            "min-height": "20px",
                            width: "20px",
                            height: "20px",
                            "box-shadow": "0"
                          }
                        },
                        [_vm._v(_vm._s(type.name))]
                      )
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _vm.receptionPdfReport
                ? _c(
                    "v-list-tile-content",
                    {
                      staticClass: "pa-1",
                      staticStyle: {
                        "border-top": "0.5px solid #404040",
                        "margin-top": "10px"
                      },
                      on: {
                        click: function($event) {
                          _vm.handleViewPdf()
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "inline-block",
                            "margin-top": "10px"
                          }
                        },
                        [
                          _c("div", {
                            staticStyle: {
                              "margin-top": "7px",
                              "margin-right": "7px",
                              float: "left",
                              "background-color": "white",
                              width: "7px",
                              height: "7px",
                              "border-radius": "1.5px"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                cursor: "pointer",
                                "min-width": "20px",
                                "min-height": "20px",
                                width: "20px",
                                height: "20px",
                                "box-shadow": "0"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("RECEPTION_VIEW_PDF")))]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    : _c("reception-sidebar-loader")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdeab9f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdeab9f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/mh-reception/components/mh-reception-sidebar/template.html
// module id = null
// module chunks = 